import React, { useState, useEffect } from "react";
import { ChevronDown } from "react-feather";
import GridModal from "./Modals/GridModal";
import GridModal3 from "./Modals/GridModal3";
import RegistrationService from "../services/registration";
import PurchaseService from "../services/Purchase";

const Modal = ({
  disabledInput,
  productImage,
  labelName,
  page,
  requiredStar,
  options = [],
  selectedValue,
  onChange = () => {},
  setSelectedValue,
  msg,
  disabled = false,
  hasImage = false,
  screen = "",
  heading,
  selectedItem,
  searchBar = true,

}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [isDealerSearchOpen, setIsDealerSearchOpen] = useState(false);
  const [dealerSelectList, setDealerSelectList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [headings, setHeadings] = useState(heading);

  // Fix
  const [selected, setSelected] = useState({id: '', title: ''});
  const [errTxt, setErrTxt] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [searchData, setSearchData] = useState([1]);
  const [showSearchBox, setShowSearchBox] = useState(searchBar);
  const [modalSearchTerm, setModalSearchTerm] = useState("");

      React.useEffect(() => {
          if (!showOptions && page === 'searchFilter') {
              setSearchTerm('');
          }
      }, [showOptions, page]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isDealerSearchOpen &&
        !event.target.closest(".modal-content")
      ) {
        setIsDealerSearchOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDealerSearchOpen]);

  useEffect(() => {
    if (!isDealerSearchOpen) {
      setSearchQuery(""); 
      setDealerSelectList([]); 
      setSelected({id: '', title: ''});
    }
  }, [isDealerSearchOpen]);

  useEffect(() => {
    const clearSelected = (e) => {
      e.stopPropagation();
      if (showOptions) {
        setShowOptions(false);
      }
    };
    window.addEventListener("click", clearSelected);
    return () => window.removeEventListener("click", clearSelected);
  }, [showOptions]);

  const handleOptionClick = (option) => {
    if (disabled) return;
    setSelectedValue(option);
    setShowOptions(false);
    
    onChange(option);
  };

  const handleShowDropdownClick = (e) => {
    e.stopPropagation();
    if (!disabled) {
      setShowOptions(!showOptions);
    }
  };

  const filteredOptions = options && Array.isArray(options) ? 
    options.filter((option) => option.title?.toLowerCase().includes((searchTerm|| "").toLowerCase())) 
    : [];

      useEffect(() => {
        if (selectedItem?.id == '') {
          setSelected({id: '', title: ''});
        } else {
          setSelected(selectedItem);
        }
      }, [selectedItem]);

  useEffect(() => {
    if (selectedItem?.id == '') {
      setSelected({id: '', title: ''});
    } else {
      setSelected(selectedItem);
    }
  }, [selectedItem]);

  const onSearch = async () => {
    try {

      let isNum = /^\d+$/.test(searchQuery.trim());
      if(isNum && searchQuery.trim().length < 10) {
        setErrTxt('Please enter complete mobile no. or SAP Code');
        return false;
      }

      if(searchQuery.trim().length >= 3) {
        setDealerSelectList([]);
        setData([]);
        setLoading(true);
        setErrTxt('');
        let payload = {
          search_str: searchQuery.trim().toLowerCase(),
        };
        const response = await RegistrationService.salesGetAllSearchedDealer(payload);

        if (response?.success && response?.response?.dealerDetails?.length) {
          const dealers = response.response.dealerDetails.map((dealer) => ({
            id: dealer?.id,
            // title: `${dealer.full_name} (${dealer.dealer_business_name} - ${dealer.id_extern01})`,
            title: dealer?.dealer_business_name +
                  ' ( M : ' +
                  dealer?.phone_number +
                  ', SAP Code : ' +
                  dealer?.id_extern01 +
                  ')',
          }));
          setDealerSelectList(dealers);
          setData(dealers);
          setSearchData(dealers);
          setLoading(false);
      } else {
        setLoading(false);
        setSearchData([1]);
      }
      } else {
        setErrTxt('Please enter atleast 3 characters');
      }

    // if(selected?.id == '--' && searchQuery.trim().length > 0) {
    //   const getData = setTimeout(() => {

    //     fetchDealerList();
    //   }, 2000);

    //   return () => {
    //     clearTimeout(getData);
    //   };
    // }
    // fetchDealerList();
      } catch (err) {
        setLoading(false);
      }
  }

  useEffect(() => {
    
    if(searchQuery.trim().length > 0) {
      const getData = setTimeout(() => {
        onSearch();
      }, 5000);
      return () => {
        clearTimeout(getData);
      };
    }
  }, [searchQuery]);

  // const handleSearchOtherDealers = () => {
  //   setModalSearchTerm(currentInputValue); // currentInputValue = input from main screen
  //   setShowModal(true);
  // };

  return (
    <>
      <div className={`selectBoxWrap ${disabledInput ? "disabledInput" : ""}`}>
        <label className="selectDropBoxLabel form-label">
          {labelName} <span className="redStar">{requiredStar}</span>
        </label>
        <div
          className={`selectDropBox ${disabled ? "disabled" : ""}`}
          onClick={handleShowDropdownClick}
        >
          <div className="registrationTopText">
            <p className="mb-0">{selectedValue?.title ? selectedValue?.title : <span style={{ color: 'grey' }}>Select</span>}</p>
            {!disabled && <div className="arrow-icon">{<ChevronDown />}</div>}
          </div>
        </div>

        {page !== "searchFilter" && showOptions && !hasImage && (
          <div className="selectDropDownOptionBox">
            <ul>
              {options.map((option, index) => (
                <li
                  key={index}
                  onClick={() => handleOptionClick(option)}
                  className={`${
                    selectedValue?.title === option.title ? "selectedOption" : ""
                  } ${option.productImage ? "selectedBlockWithImage" : ""}`}
                >
                  {option.title}
                  {option.productImage && (
                    <span className="optionImage">
                      <img src={option.productImage} alt={option.title} />
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}

        {page === "searchFilter" && showOptions && (
          <div className="selectDropDownOptionBox coloredOptionBox">
            <div className="srchFilterBox" onClick={(e) => e.stopPropagation()}>
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <ul>
              {filteredOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleOptionClick(option)}
                  className={
                    selectedValue?.title === option.title ? "selectedOption" : ""
                  }
                >
                  {option.title}
                  {option.productImage && (
                    <span className="optionImage">
                      <img src={option.productImage} alt={option.title} />
                    </span>
                  )}
                </li>
              ))}

              <li
                className="searchFilterBtn"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchQuery(searchTerm)
                  setIsDealerSearchOpen(true);
                }}
              >
                <button className="searchFilterBtnText">
                  Search Other Dealers
                </button>
              </li>
            </ul>
          </div>
        )}

        {hasImage && (
          <GridModal3
            title={labelName}
            show={showOptions}
            data={options}
            hasImage={true}
            selected={selectedValue}
            setSelected={setSelectedValue}
          />
        )}

        <GridModal3
          title="Search Other Dealers"
          show={isDealerSearchOpen}
          data={dealerSelectList}
          hasImage={false}
          selected={searchQuery}
          setSelected={setSearchQuery}
          setSelectedValue={setSelectedValue}
          onClose={() => setIsDealerSearchOpen(false)}
          onHide={() => setIsDealerSearchOpen(false)}
          loading={loading}
          // initialSearch={externalSearchText}
        />
      </div>
    </>
  );
};

export default Modal;
